<template>
  <div>
    <div v-if="showTitle" class="mb-4 text-h2">{{ $t('profile.basicData') }}</div>
    <v-row no-gutters justify="space-between" class="flex-column flex-md-row my-n2">
      <v-col class="pr-xxl-2 my-2 input_holder col-12 col-xxl-6">
        <FirstName :disabled="userDeactivated" :form-name="formName" />
      </v-col>
      <v-col class="pl-xxl-2 my-2 input_holder col-12 col-xxl-6">
        <LastName :disabled="userDeactivated" :form-name="formName" />
      </v-col>
      <v-col class="pr-xxl-2 my-2 input_holder col-12 col-xxl-6">
        <Email
          disabled
          :value="$auth.user.email"
          :required-input="false"
          :form-name="formName"
          :email-help-text="$t('profile.emailNote')"
        />
      </v-col>
      <v-col class="pl-xxl-2 my-2 input_holder col-12 col-xxl-6">
        <Phone
          show-placeholder
          :required-input="false"
          :help-text="$t('profile.phoneNote')"
          :form-name="formName"
          :prefix-selected="
            phoneFormatted($auth.user.phone) ? phoneFormatted($auth.user.phone).prefix : ''
          "
          :disabled="userDeactivated"
          disable-gtm
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import formGtm from '@/mixins/formGtm';

export default {
  name: 'BasicData',
  mixins: [formGtm],
  props: {
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      userDeactivated: 'profile/dashboard/userDeactivated'
    })
  }
};
</script>
